import axios from 'axios'

export default {
  initStore ({ dispatch }) {
    dispatch('loadUser')
    this.state.groups_promise = dispatch('loadGroups')
    this.state.quarters_promise = dispatch('loadQuarters')
    this.state.backtests_promise = dispatch('loadTrackedBacktests')
    this.state.sectors_promise = dispatch('loadSectors')
    this.state.email_alerts_promise = dispatch('loadEmailAlerts')
    this.state.classifications_promise = dispatch('loadClassifications')
    this.state.countries_promise = dispatch('loadCountries')
    this.state.sec_code_states_promise = dispatch('loadSECCodeStates')
    this.state.states_promise = dispatch('loadStates')
    this.state.ww_groups_promise = dispatch('loadWWGroups')
    this.state.ownershiptcodes_promise = dispatch('loadOwnershipCodes')
    this.state.insider_alerts_promise = dispatch('loadInsiderAlerts')
  },
  initPeerGroupStore ({ dispatch }) {
    this.state.classifications_promise = dispatch('loadClassifications')
  },
  initFilerStore ({ dispatch }) {
    dispatch('loadUser')
    this.state.quarters_promise = dispatch('loadQuarters')
    this.state.sectors_promise = dispatch('loadSectors')
    this.state.ww_groups_promise = dispatch('loadWWGroups')
  },

  loadUser ({ commit }) {
    axios.get('/dashboard/user.json')
      .then(response => commit('SET_USER', (response.data && response.data.id ? response.data : null)))
      .catch(error => console.log(error))
  },

  loadGroups ({ commit }) {
    return axios.get('/dashboard/groups.json?isArray=1')
      .then(response => commit('SET_GROUPS', response.data))
      .catch(error => console.log(error))
  },

  loadQuarters ({ commit }) {
    return axios.get('/dashboard/quarter')
      .then(response => commit('SET_QUARTERS', response.data))
      .catch(error => console.log(error))
  },

  loadTrackedBacktests ({ commit }) {
    return axios.get('/dashboard/backtest_tracking.json', { params: { isArray: true } })
      .then(response => commit('SET_BACKTESTS', response.data))
      .catch(error => console.log(error))
  },
  loadInsiderAlerts ({ commit }) {
    return axios.get('/dashboard/insider_alerts.json', { params: { isArray: true } })
      .then(response => commit('SET_INSIDER_ALERTS', response.data))
      .catch(error => console.log(error))
  },

  loadSectors ({ commit }) {
    return axios.get('/dashboard/sector')
      .then(response => commit('SET_SECTORS', response.data))
      .catch(error => console.log(error))
  },

  loadEmailAlerts ({ commit }) {
    return axios.get('/dashboard/email_alert/email_alerts.json')
      .then(response => commit('SET_EMAIL_ALERTS', response.data))
      .catch(error => console.log(error))
  },

  loadClassifications ({ commit }) {
    return axios.get('/dashboard/fund_classifications')
      .then(response => commit('SET_CLASSIFICATIONS', response.data))
      .catch(error => console.log(error))
  },

  loadCountries ({ commit }) {
    return axios.get('/dashboard/country')
      .then(response => commit('SET_COUNTRIES', response.data))
      .catch(error => console.log(error))
  },

  loadSECCodeStates ({ commit }) {
    return axios.get('/dashboard/sec_code_state')
      .then(response => commit('SET_SEC_CODE_STATES', response.data))
      .catch(error => console.log(error))
  },

  loadStates ({ commit }) {
    return axios.get('/dashboard/state')
      .then(response => commit('SET_STATES', response.data))
      .catch(error => console.log(error))
  },

  loadWWGroups ({ commit }) {
    return axios.get('/dashboard/groups.json', { params: { groups: 'ww', isArray: true } })
      .then(response => commit('SET_WW_GROUPS', response.data))
      .catch(error => console.log(error))
  },

  loadOwnershipCodes ({ commit }) {
    return axios.get('/dashboard/ownership_transaction_code')
      .then(response => commit('SET_OWNERSHIP_T_CODES', response.data))
      .catch(error => console.log(error))
  }
}
